var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE3Garden(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 55H61v-8.22a7.74 7.74 0 008.44-5.9A7.74 7.74 0 0061 44.43V38a2.57 2.57 0 001.08-1.82 2.62 2.62 0 003.68-3.68 2.6 2.6 0 000-5.17 2.61 2.61 0 00-3.67-3.66 2.61 2.61 0 00-5.18 0 2.6 2.6 0 00-3.66 3.66 2.61 2.61 0 000 5.19 2.61 2.61 0 003.66 3.67A2.581 2.581 0 0058 38v10.43a7.75 7.75 0 00-8.44-3.55 7.74 7.74 0 008.44 5.9V55H42V28.81L21 14.28 0 29.11V59h76v-4h-4zm-8.59-23s-.01 0 0 0zm-6-2.13A2.14 2.14 0 1159.52 32a2.14 2.14 0 01-2.14-2.15l.03.02zM38 55H24v-9h-6v9H4V31.22l17-12 17 11.69V55zm-6-15h-6v-6h6v6zm-22-6h6v6h-6v-6z",
    fill: "#040404"
  })));
}
export default __webpack_public_path__ + "static/media/E3_Garden.b17fbbbb.svg";
export { SvgE3Garden as ReactComponent };